import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { CareCreditEnrollBody } from './care-credit-enroll-body';
import { CareCreditEnrollGenericNavigation } from './navigation/care-credit-enroll-generic-navigation';

export const CareCreditEnrollNavigationSwitch = () => {
  return <StepNavigationSwitch body={CareCreditEnrollBody} generic={CareCreditEnrollGenericNavigation} />;
};
